import {useQuery} from '@tanstack/react-query';
import {
	GetProcedureV3Request,
	GetProcedureV3Response,
} from 'domain/usecases/private/guide-flow/medical-guide/get-procedure-v3';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getHealthProcedureData} from 'presentation/modules/guide/health/services/getHealthProcedureData';

type UseHealthProcedureDataQueryParams = Pick<GetProcedureV3Request, 'cdProcedimento'> & {
	enabled?: boolean;
};

export function useHealthProcedureDataQuery({
	cdProcedimento,
	enabled = true,
}: UseHealthProcedureDataQueryParams) {
	return useQuery<GetProcedureV3Response>({
		queryKey: [QUERY_KEYS.HEALTH_PROCEDURE_DATA, {cdProcedimento}],
		queryFn: ({signal}) => getHealthProcedureData({cdProcedimento, signal}),
		enabled: enabled && !!cdProcedimento,
	});
}
